import React from "react";
import { Inbox } from "lucide-react";

export default function EmptyState({ title = "Nada por aqui ainda", description = "", action, icon: Icon = Inbox, testid }) {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-dashed border-border/90 bg-card/55 px-5 py-10 text-center sm:px-8 sm:py-12" data-testid={testid}>
      <div className="pointer-events-none absolute left-1/2 top-0 h-24 w-48 -translate-x-1/2 rounded-full bg-primary/8 blur-3xl" />
      <div className="relative mx-auto mb-4 grid size-12 place-items-center rounded-2xl border border-primary/15 bg-primary/10 text-primary shadow-[0_8px_24px_hsl(var(--primary)/0.08)]">
        <Icon className="size-5" />
      </div>
      <h3 className="relative text-base font-semibold tracking-[-0.02em] sm:text-lg">{title}</h3>
      {description && <p className="relative mx-auto mb-5 mt-1.5 max-w-md text-sm leading-relaxed text-muted-foreground">{description}</p>}
      {action && <div className="relative flex justify-center">{action}</div>}
    </div>
  );
}
